<template>
  <div class="container-fluid">
    <b-card class="" no-body>
      <b-card-header class="py-0 pl-0">
        <b-card-body class="py-2">
          <b-row>
            <b-col xl="5" lg="4" md="3"
              ><b-card-title class="card-title-doorder my-3"
                >Retailers</b-card-title
              ></b-col
            >
            <b-col xl="7" lg="8" md="9">
              <b-row class="justify-content-end filterContrainerDiv my-2">
                <b-col xl="4" lg="5" md="6" sm="6" class="px-md-1">
                  <div id="businessTypeP" class="">
                    <select
                      id="selectFilter"
                      data-style="select-with-transition"
                      class="form-control form-control-filter-doorder"
                      name="business_type"
                    >
                      <option value="">Select business type</option>
                    </select>
                  </div>
                </b-col>
                <b-col xl="4" lg="3" md="3" sm="4" class="px-md-1">
                  <!-- <v-select
               ref="filtertype" id="filtertypeselect"
                    :options="businessTypes"
                    :reduce="(item) => item.code"
                    placeholder="Select type"
                     v-model="business_typee"
                  ></v-select> -->
                  <b-button
                    variant="doorder-primary"
                    class="
                      btn-bumblebee btn-doorder btn-doorder-filter
                      w-100
                      my-0
                    "
                    @click="clickExport"
                    >Export</b-button
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row></b-card-body
        >
      </b-card-header>
    </b-card>

    <b-card>
      <b-table-simple
        class="table table-no-bordered table-hover doorderTable"
        id="retailersTable"
        hover
        responsive
      >
        <b-thead>
          <b-tr>
            <b-th>Business Type</b-th>
            <b-th>Retailer Name</b-th>
            <b-th class="text-center">Locations No.</b-th>
            <b-th>Payment Method</b-th>
            <b-th class="text-center">Actions</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="retailer in retailers"
            :key="retailer.id"
            @click="clickViewRetailerRow($event, retailer.id)"
          >
            <b-td>{{ retailer.business_type }}</b-td>
            <b-td>{{ retailer.name }}</b-td>

            <b-td class="text-center">{{ retailer.locations_count }}</b-td>
            <b-td>{{ retailer.payment_method }}</b-td>
            <b-td class="centerTd">
              <b-button variant="action-table-doorder" class="edit mb-1"
              @click="clickEditRetailer(retailer.id)"
                ><img
                  src="@/assets/images/doorder/edit-icon.png"
                  alt="edit icon"
              /></b-button>
              <b-button
                variant="action-table-doorder "
                class="remove mb-1"
                @click="clickDeleteRetailer(retailer.id)"
                ><img
                  src="@/assets/images/doorder/delete-icon.png"
                  alt="delete icon" /></b-button
            ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-card>
    <!-- delete modal -->
    <DeleteRetailerModel :retailer_id="selected_retailer_id" />
  </div>
</template>


<script>
import $ from "jquery";
import axios from "axios";

import DeleteRetailerModel from "./DeleteRetailerModel.vue";

var table;
export default {
  name: "DoorderRetailersList",
  components: { DeleteRetailerModel },
  data() {
    return {
      retailers: [],

      table: null,
      businessTypes: [],
      business_typee: null,

      selected_retailer_id: null,
    };
  },

  mounted() {
    // this.overlay_show = true;
    this.initTable();
    this.getAcceptedRetaailers();

    //
  },
  methods: {
    getAcceptedRetaailers() {
      // console.log("here call user list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      axios
        .get("/retailer/accepted-list", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          // console.log(table);
          // table.destroy();
          if (table != null) {
            table.destroy();
          }
          console.log(response);
          this.retailers = response.data;
          // console.log(this.rowsData);
          var temp = this;
          setTimeout(function () {
            // console.log(table);
            // console.log(table == null);
            if (table == null) {
              temp.initTable();
            } else {
              // console.log(table.data());
              temp.initTable();
              // console.log(table.data());
              // table.destroy();
              // $('#sampleTable').DataTable().clear()
              // $('#sampleTable').DataTable().destroy()
              //
            }
          }, 1000);
          this.overlay_show = false;
          // table.ajax.reload()
        });
    },
    initTable() {
      let temp = this;
      table = $("#retailersTable").DataTable({
        // sDom: 'flti<"table_selected_rows">p',
        // // buttons: [
        // //    'csv',
        // // ],
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        // scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [-1, 5, 10, 25, 50, 100],
          ["All", 5, 10, 25, 50, 100],
        ],
        columnDefs: [
          {
            targets: -1,
            orderable: false,
          },
        ],
        // columns: this.$parent.columns,
        // data: this.$parent.rowsData,
        pagingType: "full_numbers",
        language: {
          // paginate: {
          //   previous: "<i class='fas fa-angle-left'></i>",
          //   next: "<i class='fas fa-angle-right'></i>",
          // },
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
        initComplete: function () {
          var column = this.api().column(0);
          var select = $("#selectFilter")
            .appendTo($("#businessTypeP").empty().text(""))
            .on("change", function () {
              var val = $.fn.dataTable.util.escapeRegex($(this).val());
              //   console.log("====",val)
              //    temp.$refs.filtertype.$emit("option:selected", temp.business_typee);
              //    console.log(temp.business_typee)
              column.search(val ? "^" + val + "$" : "", true, false).draw();
            });
          column
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
              select.append('<option value="' + d + '">' + d + "</option>");
              console.log(temp.businessTypes);
              temp.businessTypes.push({ label: d, code: d });
            });
        },
      });

      // $("#selectAll").change(function () {
      //   console.log(table.rows());

      //   if (this.checked) {
      //     table.rows().every(function () {
      //       $(this.node()).addClass("selected");
      //       $(this.node()).children().children().attr("checked", "checked");
      //       console.log($(this.node()));
      //       console.log($(this.node()).children());
      //       console.log($(this.node()).children().children());
      //     });
      //   } else {
      //     table.rows().every(function () {
      //       $(this.node()).removeClass("selected");
      //       $(this.node()).children().children().attr("checked", false);
      //     });
      //   }
      //   console.log($('input[name="selectedUsers[]"]:checked'));
      //   $("#selectAll").val(this.checked);
      // });
    },
    clickDeleteRetailer(id) {
      console.log("delete retailer from current list ", id);
      this.selected_retailer_id = id;
      this.$root.$emit("bv::show::modal", "delete-retailer-modal-doorder");
    },
    clickEditRetailer(id) {
      console.log("click edit retailer from current list ", id);
      this.$router.push({
        name: "DoorderRetailerEdit",
        params: { id },
      });
    },
    clickViewRetailerRow(e, id) {
      console.log("click retailer view " + id);
      e.preventDefault();

      if (e.target.cellIndex == undefined) {
      } else {
        this.$router.push({
          name: "DoorderRetailerSingleView",
          params: { id },
        });
      }
    },
    clickExport() {
      console.log("click export");

      axios
        .get("/retailer/accepted-list?export_type=excel", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DOORDER",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          var fileURL = response.data.export_url;
          //window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          // fileLink.setAttribute("download", "retailers.xlsx");
          document.body.appendChild(fileLink);

          fileLink.click();
          fileLink.remove();
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/retailers/CurrentList.vue